import { defineMessages } from 'react-intl';

/** The copy of the Kit tab of the release page (design assets-rethink b1, b4, d2, d3). */
export const kitMessages = defineMessages({
  // Summary (b1 `.kit-sum`)
  summaryEyebrow: { id: 'app.sml.releases.kit.summary.eyebrow', defaultMessage: 'Release kit' },
  // QA 2026-10-28 impr2-2, mob-13: name the unit, so "6 of 11" does not read as the watermark file count.
  summaryMade: { id: 'app.sml.releases.kit.summary.madeParts', defaultMessage: '{made} of {total} kit parts made' },
  summaryMaking: { id: 'app.sml.releases.kit.summary.making', defaultMessage: '{count} making' },
  summaryFailed: { id: 'app.sml.releases.kit.summary.failed', defaultMessage: '{count} failed' },
  summaryNotMade: { id: 'app.sml.releases.kit.summary.notMade', defaultMessage: '{count} not made' },
  summaryWaits: {
    id: 'app.sml.releases.kit.summary.waits',
    defaultMessage: '{count, plural, one {# waits for you} other {# wait for you}}',
  },
  makeMissing: {
    id: 'app.sml.releases.kit.summary.makeMissing',
    defaultMessage: '{count, plural, one {Make the missing one} other {Make the # missing ones}}',
  },
  makeMissingCost: {
    id: 'app.sml.releases.kit.summary.cost',
    defaultMessage: 'Costs {cost, plural, one {# credit} other {# credits}} · you have {left}',
  },
  // QA finding F30: say what the click leaves for reels and videos.
  makeMissingCostLeaves: {
    id: 'app.sml.releases.kit.summary.costLeaves',
    defaultMessage:
      'Costs {cost, plural, one {# credit} other {# credits}} · you have {left} · leaves {after} for reels and videos',
  },
  // QA 2026-10-28 (imp-8, lit-8, mob-13): the button counts what one click makes now, and one line
  // names the parts that wait for something, so the counts add up.
  makeMissingNow: {
    id: 'app.sml.releases.kit.summary.makeMissingNow',
    defaultMessage: '{count, plural, one {Make the one we can make now} other {Make the # we can make now}}',
  },
  missingBlockedLead: { id: 'app.sml.releases.kit.summary.blocked.lead', defaultMessage: 'Not in this click:' },
  blockMaster: {
    id: 'app.sml.releases.kit.summary.blocked.master',
    defaultMessage: '{count, plural, one {# needs the song file} other {# need the song file}}',
  },
  blockLyrics: {
    id: 'app.sml.releases.kit.summary.blocked.lyrics',
    defaultMessage: '{count, plural, one {# needs the lyrics} other {# need the lyrics}}',
  },
  blockReleaseDay: {
    id: 'app.sml.releases.kit.summary.blocked.releaseDay',
    defaultMessage: '{count, plural, one {# needs a release day} other {# need a release day}}',
  },
  blockPlan: {
    id: 'app.sml.releases.kit.summary.blocked.plan',
    defaultMessage: '{count, plural, one {# needs a paid plan} other {# need a paid plan}}',
  },
  blockEditor: {
    id: 'app.sml.releases.kit.summary.blocked.editor',
    defaultMessage:
      '{count, plural, one {# is made in the music video editor} other {# are made in the music video editor}}',
  },
  blockCover: {
    id: 'app.sml.releases.kit.summary.blocked.cover',
    defaultMessage: '{count, plural, one {# needs the cover} other {# need the cover}}',
  },
  blockChoice: {
    id: 'app.sml.releases.kit.summary.blocked.choice',
    defaultMessage: '{count, plural, one {# needs a choice in the Studio} other {# need a choice in the Studio}}',
  },
  makeMissingFree: { id: 'app.sml.releases.kit.summary.free', defaultMessage: 'Images are free' },
  // Groups (b1 `.kgrp-h`)
  groupArtwork: { id: 'app.sml.releases.kit.group.artwork', defaultMessage: 'Song artwork' },
  groupArtworkNote: {
    id: 'app.sml.releases.kit.group.artworkNote',
    defaultMessage: 'The cover and what the stores and SmartLinks show',
  },
  groupLongVideos: { id: 'app.sml.releases.kit.group.longVideos', defaultMessage: 'Long videos' },
  groupLongVideosNote: {
    id: 'app.sml.releases.kit.group.longVideosNote',
    defaultMessage: 'Full-song videos, published one time per channel',
  },
  groupProfiles: { id: 'app.sml.releases.kit.group.profiles', defaultMessage: 'Profiles and links' },
  groupProfilesNote: {
    id: 'app.sml.releases.kit.group.profilesNote',
    defaultMessage: 'Set one time per release; the kit makes "Out now" again on release day',
  },
  // Slot names and lines
  slotCover: { id: 'app.sml.releases.kit.slot.cover', defaultMessage: 'Cover' },
  slotBanners: { id: 'app.sml.releases.kit.slot.banners', defaultMessage: 'Profile banners' },
  slotThumbnail: { id: 'app.sml.releases.kit.slot.thumbnail', defaultMessage: 'YouTube thumbnail' },
  slotZip: { id: 'app.sml.releases.kit.slot.zip', defaultMessage: 'Kit zip' },
  coverLine: { id: 'app.sml.releases.kit.slot.coverLine', defaultMessage: 'The cover of the song and its SmartLinks' },
  coverNone: { id: 'app.sml.releases.kit.slot.coverNone', defaultMessage: 'No cover yet' },
  spotifyHeaderLine: {
    id: 'app.sml.releases.kit.slot.spotifyHeaderLine',
    defaultMessage: 'Update your Spotify header with this release.',
  },
  coverSizesLine: {
    id: 'app.sml.releases.kit.slot.coverSizesLine',
    defaultMessage: '3000 · 1400 · 640 for the distributor',
  },
  motionLine: {
    id: 'app.sml.releases.kit.slot.motionLine',
    defaultMessage: 'Square 3840 and tall, for Apple Music.',
  },
  linkPreviewLine: { id: 'app.sml.releases.kit.slot.linkPreviewLine', defaultMessage: 'On the pre-save page' },
  appliedByItself: { id: 'app.sml.releases.kit.slot.appliedByItself', defaultMessage: 'Applied by itself' },
  zipLine: {
    id: 'app.sml.releases.kit.slot.zipLine',
    defaultMessage: 'One folder with every keeper of this song. No post files. The link lasts 7 days.',
  },
  zipFiles: {
    id: 'app.sml.releases.kit.slot.zipFiles',
    defaultMessage: '{count, plural, one {# file} other {# files}}',
  },
  // States (b1 `.st`)
  stateMade: { id: 'app.sml.releases.kit.state.made', defaultMessage: 'Made' },
  stateMaking: { id: 'app.sml.releases.kit.state.making', defaultMessage: 'Making' },
  stateNotMade: { id: 'app.sml.releases.kit.state.notMade', defaultMessage: 'Not made' },
  statePro: { id: 'app.sml.releases.kit.state.pro', defaultMessage: 'Pro' },
  makingPercent: { id: 'app.sml.releases.kit.making.percent', defaultMessage: 'Making · {percent}%' },
  makingQueued: { id: 'app.sml.releases.kit.making.queued', defaultMessage: 'Waits in the queue' },
  newerFailed: {
    id: 'app.sml.releases.kit.newerFailed',
    defaultMessage: 'r{failed} failed. r{ready} stays.',
  },
  newerMaking: { id: 'app.sml.releases.kit.newerMaking', defaultMessage: 'r{next} is being made. r{ready} stays.' },
  creditsBack: { id: 'app.sml.releases.kit.creditsBack', defaultMessage: 'Your credits are back.' },
  // Actions (b1 `.ks-f`)
  makeIt: { id: 'app.sml.releases.kit.action.makeIt', defaultMessage: 'Make it' },
  makeItCost: {
    id: 'app.sml.releases.kit.action.makeItCost',
    defaultMessage: 'Make it · {cost, plural, one {# credit} other {# credits}}',
  },
  tryAgain: { id: 'app.sml.releases.kit.action.tryAgain', defaultMessage: 'Try again' },
  tryAgainCost: {
    id: 'app.sml.releases.kit.action.tryAgainCost',
    defaultMessage: 'Try again · {cost, plural, one {# credit} other {# credits}}',
  },
  download: { id: 'app.sml.releases.kit.action.download', defaultMessage: 'Download' },
  downloadCount: { id: 'app.sml.releases.kit.action.downloadCount', defaultMessage: 'Download {count}' },
  publish: { id: 'app.sml.releases.kit.action.publish', defaultMessage: 'Publish' },
  howTo: { id: 'app.sml.releases.kit.action.howTo', defaultMessage: 'How?' },
  editCover: { id: 'app.sml.releases.kit.action.editCover', defaultMessage: 'Edit cover' },
  designCover: { id: 'app.sml.releases.kit.action.designCover', defaultMessage: 'Design a cover' },
  buildZip: { id: 'app.sml.releases.kit.action.buildZip', defaultMessage: 'Build the zip' },
  downloadZip: { id: 'app.sml.releases.kit.action.downloadZip', defaultMessage: 'Download the zip' },
  open: { id: 'app.sml.releases.kit.action.open', defaultMessage: 'Open {name}' },
  // b4
  staleChannel: {
    id: 'app.sml.releases.kit.staleChannel',
    defaultMessage: 'r{current} of the {name} is not on {channel}. {channel} shows r{published}.',
  },
  // d2
  emptyTitle: { id: 'app.sml.releases.kit.empty.title', defaultMessage: 'Nothing made for {title} yet' },
  emptyBody: {
    id: 'app.sml.releases.kit.empty.body',
    defaultMessage:
      'The kit makes the cover sizes, the Canvas, the banners and the link preview in one go. The images are free. The long videos wait for your go.',
  },
  emptyMake: { id: 'app.sml.releases.kit.empty.make', defaultMessage: 'Make the kit' },
  emptyStudio: { id: 'app.sml.releases.kit.empty.studio', defaultMessage: 'Pick one in Studio' },
  // d3
  lockedLine: {
    id: 'app.sml.releases.kit.locked.line',
    defaultMessage: 'Make the {name} for {title} — on Pro.',
  },
  seePro: { id: 'app.sml.releases.kit.locked.seePro', defaultMessage: 'See Pro' },
  askOwner: { id: 'app.sml.releases.kit.locked.askOwner', defaultMessage: 'Ask the owner to upgrade.' },
});
